import { useApolloClient } from '@apollo/client'
import { useDispatch } from 'react-redux';
import { ContabilidadPropietarioDataSource } from '../../data/datasources/ContabilidadPropietario.datasource';
import { loadingModal } from 'src/redux-app';
import { toast } from 'lib.front';
import { paramsGetDatosPropietarioContabilidad } from '../../bussines/params/ContabilidadPropietario.params';

export const useContabilidadPropietario = () => {
    const apolloClient = useApolloClient();
    const dispatch = useDispatch();
    const dataSource = new ContabilidadPropietarioDataSource(apolloClient);
    const getContabilidadPropietarioList = async () => {
        try {
            dispatch(loadingModal(true));
            const response = await dataSource.getContabilidadPropietarioList();
            if (response === null) {
                throw new Error('Error al consultar, vuelva a intenar en unos minutos');
            }
            return response;
        } catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            toast.showError(message);
            return undefined;
        } finally {
            dispatch(loadingModal(false));
        }
    }
    const getDatosContabilidadPropietario = async (params: paramsGetDatosPropietarioContabilidad) => {
        try {
            dispatch(loadingModal(true));
            const response = await dataSource.getDatosContabilidadPropietario(params);
            return response;
        } catch (err) {
            const message = err instanceof Error ? err.message : String(err);
            toast.showError(message);
            return undefined;
        } finally {
            dispatch(loadingModal(false));
        }
    }
    return { getContabilidadPropietarioList, getDatosContabilidadPropietario }
}
